/* HYV Premium — kit toggle only (live port of item 15).
   The draft's notify-me / sold-out-swatch script (item 19) is deliberately
   not included on the live theme. */
/* Kit toggle (snippets/hyv-kit-toggle.liquid)
   1. Keep each companion's variant matched to the bottle colour on screen.
   2. When the bottle is added, add the checked companions to the same cart
      and ask Impact to refresh its drawer. */
(function () {
  'use strict';
  var kit = document.querySelector('[data-hyv-kit]');
  if (!kit) return;

  var items = Array.prototype.slice.call(kit.querySelectorAll('[data-hyv-kit-item]'));
  var foot = kit.querySelector('[data-hyv-kit-foot]');
  var money = function (paise) {
    var n = Math.round(paise / 100);
    return '₹' + n.toLocaleString('en-IN');
  };

  function currentColour() {
    // Impact prints "Color: <span>Cashmere Beige</span>" above the swatches.
    var legend = document.querySelector('.variant-picker__option-info .h-stack span');
    return legend ? legend.textContent.trim() : (kit.getAttribute('data-host-color') || '');
  }

  function rematch() {
    var colour = currentColour();
    items.forEach(function (input) {
      var ids = JSON.parse(input.getAttribute('data-variants') || '[]');
      var titles = JSON.parse(input.getAttribute('data-titles') || '[]');
      var avail = JSON.parse(input.getAttribute('data-avail') || '[]');
      var prices = JSON.parse(input.getAttribute('data-prices') || '[]');
      var idx = -1;
      for (var i = 0; i < titles.length; i++) {
        if (titles[i] === colour && avail[i]) { idx = i; break; }
      }
      if (idx === -1) {
        for (var j = 0; j < avail.length; j++) { if (avail[j]) { idx = j; break; } }
      }
      if (idx === -1) return;
      input.setAttribute('data-variant-id', ids[idx]);
      input.setAttribute('data-price', prices[idx]);
      var row = input.closest('.hyv-kit__row');
      var sub = row.querySelector('[data-hyv-kit-sub]');
      var price = row.querySelector('[data-hyv-kit-price]');
      if (sub) sub.textContent = titles[idx];
      if (price) price.textContent = '+ ' + money(prices[idx]);
    });
    total();
  }

  function total() {
    if (!foot) return;
    var sum = 0, n = 0;
    items.forEach(function (i) { if (i.checked) { sum += parseInt(i.getAttribute('data-price'), 10) || 0; n++; } });
    if (!n) { foot.hidden = true; return; }
    foot.hidden = false;
    foot.textContent = n + (n > 1 ? ' add-ons' : ' add-on') + ' · ' + money(sum) + ' extra, shipped in the same box.';
  }

  items.forEach(function (i) { i.addEventListener('change', total); });
  document.addEventListener('variant:change', rematch);
  rematch();

  // Add companions after the bottle lands in the cart. Impact dispatches
  // 'cart:change' once /cart/add.js succeeds; the click-arm guard means a
  // drawer quantity change elsewhere on the page never triggers this.
  var armed = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('form[action*="/cart/add"] button[type="submit"], .product-form__buy-buttons button[type="submit"]') : null;
    if (btn) armed = true;
  }, true);

  document.addEventListener('cart:change', function () {
    if (!armed) return;
    armed = false;
    var add = items.filter(function (i) { return i.checked; }).map(function (i) {
      return { id: parseInt(i.getAttribute('data-variant-id'), 10), quantity: 1 };
    });
    if (!add.length) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: add })
    }).then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {});
  });
})();
